import { __assign, __generator } from "tslib";
import { all, put, call, takeEvery, select, } from 'redux-saga/effects';
import { deleteStatus, submitStatus, submitStatusSuccess, submitStatusFailure, } from './actions';
import { convertToServerXhrPayload } from '../DaEditorWrapper/utils';
import { request } from '../xhr';
import { normalize } from '../redux/normalizr';
import { putEntities } from '../redux/entities/actions';
import { deviationSchema } from '../redux/normalizr/schemas/deviation';
import ddt from '@wix/da-ddt';
import { getDeviationUrl } from '../DeviationViews/_helpers';
import { editDeviationSuccess } from '../redux/deviations/actionCreators';
import { logBiEvent } from '../biLogger/redux/saga';
import { ResourceType } from '../types/resource';
import { PureBiData } from '@wix/da-bi/pkg/events';
import { flagEnabled } from '../redux/flags/selectors';
import { Url } from '@wix/da-url';
export function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error',
            };
        }
        ddt.log('statusupdate', 'faking the response!');
        var deviationsByType = require('@wix/da-sample-data').deviationsByType; // eslint-disable-line global-require
        var deviation = deviationsByType.statuses[0];
        if (options.url === '/status/create' || options.url === '/status/update') {
            deviation.status.textContent = {
                excerpt: options.data.editorSnippet,
                html: {
                    type: 'draft',
                    markup: JSON.parse(options.data.editorRaw),
                    features: JSON.parse(options.data.editorFeatures),
                },
            };
        }
        return { deviation: deviation };
    }
}
function submitStatusSaga(action) {
    var _a, editorContent, editorRawState, features, statusid, _b, backgroundProps, refreshAfterSubmit, visibility, isEdit, submit_to_postsfeed, backgroundType, gradient, imageDisplayMode, imageTint, pattern, imageDeviation, snakeCaseBackgroundParams, data, method, url, result, publishData, publishResult, _c, statusId, entities, resultActions, deviation;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = action.payload, editorContent = _a.editorContent, editorRawState = _a.editorRawState, features = _a.features, statusid = _a.statusId, _b = _a.backgroundProps, backgroundProps = _b === void 0 ? {} : _b, refreshAfterSubmit = _a.refreshAfterSubmit, visibility = _a.visibility;
                ddt.log('statusupdate', 'payload', action.payload);
                isEdit = statusid !== undefined;
                return [4 /*yield*/, select(flagEnabled, 'submit_to_postsfeed')];
            case 1:
                submit_to_postsfeed = _d.sent();
                backgroundType = backgroundProps.backgroundType, gradient = backgroundProps.gradient, imageDisplayMode = backgroundProps.imageDisplayMode, imageTint = backgroundProps.imageTint, pattern = backgroundProps.pattern, imageDeviation = backgroundProps.imageDeviation;
                snakeCaseBackgroundParams = {
                    background_type: backgroundType,
                    image_tint: imageTint,
                    image_deviationid: imageDeviation === null || imageDeviation === void 0 ? void 0 : imageDeviation.deviationId,
                    image_display_mode: imageDisplayMode,
                    gradient: gradient,
                    pattern: pattern,
                };
                data = __assign(__assign(__assign({}, convertToServerXhrPayload(editorRawState, editorContent, features)), snakeCaseBackgroundParams), { statusid: statusid });
                method = 'post';
                url = isEdit ? '/status/update' : '/status/create';
                ddt.log('statusupdate', 'request', __assign(__assign({}, data), { url: url }));
                return [4 /*yield*/, call(request, {
                        method: method,
                        url: url,
                        data: data,
                    }, fakeResponse)];
            case 2:
                result = _d.sent();
                ddt.log('statusupdate', 'response', result);
                if (!(result && !result.error)) return [3 /*break*/, 9];
                publishData = {
                    statusid: result.deviation.deviationId,
                    tiers: (visibility === null || visibility === void 0 ? void 0 : visibility.type) === 'tier'
                        ? visibility.tiers.map(function (tier) { return tier.deviationId; })
                        : undefined,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: '/status/publish',
                        data: publishData,
                    }, fakeResponse)];
            case 3:
                publishResult = _d.sent();
                ddt.log('statusupdate', 'response publish', publishResult);
                if (!(!publishResult || publishResult.error)) return [3 /*break*/, 5];
                if (result && result.errorCode === 302) {
                    window.location.replace(result.errorDetails.redirectUrl);
                }
                return [4 /*yield*/, put(submitStatusFailure({ error: result === null || result === void 0 ? void 0 : result.error_description }))];
            case 4:
                _d.sent();
                ddt.log('statusupdate', 'failure', result === null || result === void 0 ? void 0 : result.error_description);
                _d.label = 5;
            case 5:
                _c = normalize(publishResult.deviation, deviationSchema), statusId = _c.result, entities = _c.entities;
                if (!!isEdit) return [3 /*break*/, 7];
                return [4 /*yield*/, call(logBiEvent, PureBiData({
                        evid: 11,
                        group_exclusive: false,
                        itemid: publishResult.deviation.deviationId,
                        typeid: ResourceType.STATUS_DEVIATION,
                    }))];
            case 6:
                _d.sent();
                _d.label = 7;
            case 7:
                resultActions = [
                    put(putEntities({ entities: entities })),
                    // The statusId returned from normalize will be a string, but this expects a non-normalized ID, so pull straight from the result
                    put(submitStatusSuccess({ statusId: publishResult.deviation.deviationId })),
                ];
                if (isEdit) {
                    resultActions.push(put(editDeviationSuccess({ deviation: publishResult.deviation })));
                }
                return [4 /*yield*/, all(resultActions)];
            case 8:
                _d.sent();
                ddt.log('statusupdate', 'success', statusId);
                // redirect
                if (refreshAfterSubmit) {
                    window.location.reload();
                }
                else {
                    deviation = publishResult.deviation;
                    window.location.assign(submit_to_postsfeed ? Url.browsePostsLink() : getDeviationUrl(deviation));
                }
                return [3 /*break*/, 11];
            case 9:
                if (result && result.errorCode === 302) {
                    window.location.replace(result.errorDetails.redirectUrl);
                }
                return [4 /*yield*/, put(submitStatusFailure({ error: result === null || result === void 0 ? void 0 : result.error_description }))];
            case 10:
                _d.sent();
                ddt.log('statusupdate', 'failure', result === null || result === void 0 ? void 0 : result.error_description);
                _d.label = 11;
            case 11: return [2 /*return*/];
        }
    });
}
function deleteStatusSaga(action) {
    var statusid, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                statusid = action.payload.statusId;
                ddt.log('statusupdate', 'deleting', statusid);
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: "/status/delete",
                        data: { statusid: statusid },
                    }, fakeResponse)];
            case 1:
                result = _a.sent();
                ddt.log('statusupdate', 'response', result);
                return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(submitStatus, submitStatusSaga),
                    takeEvery(deleteStatus, deleteStatusSaga),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map